<template>
  <div>
    <div class="d-flex justify-space-between mt-4 pr-3 form__title-text">
      <div class="error--text">
        {{ get(inventory, 'name', 'Kho chưa có tên') }}
      </div>
      <div class="d-flex">
        <div class="error--text mr-6">
          {{
            `Đã lên lịch: ${
              inventory.schedules && inventory.schedules.length
                ? Number(get(inventory, 'quantity', 0)).toLocaleString()
                : 0
            }`
          }}
        </div>
        <div class="error--text">
          {{ `Tổng: ${Number(totalQuantity).toLocaleString() || 0}` }}
        </div>
      </div>
    </div>
    <div class="mt-3">
      <v-form ref="form">
        <div v-for="(item, index) in data.schedules" :key="index">
          <div class="d-flex">
            <div class="mb-2" style="width: 100%">
              <SelectDate
                @change="val => onChangeDate(val, item)"
                :existedDate="get(item, 'deliveredAt', null)"
                :isShowLabel="false"
                :hideDetails="true"
                class="mb-4 mr-3 mt"
                placeholder="Chọn ngày"
                :rules="[$rules.date, $rules.required]"
              ></SelectDate>
              <BaseInput
                type="number"
                label="Số lượng"
                placeholder="Nhập số lượng"
                v-model="item.quantity"
                :rules="[$rules.required, $rules.isNumber]"
                class="mb-4 mr-3 required"
              />
              <BaseInput
                name="code"
                v-model="item.billCode"
                label="Mã hoá đơn"
                placeholder="Mã hoá đơn"
                class="mb-4 mr-3"
              />
              <div class="mr-3 d-flex justify-end">
                <div
                  class="delete-schedule-link"
                  v-if="item.fakeId && data.schedules.length > 1"
                  @click="() => onRemove(item.fakeId, index)"
                >
                  Xoá ngày giao hàng
                </div>
              </div>
              <v-divider v-if="index !== data.schedules.length - 1" class="mb-3 mt-6" />
            </div>
          </div>
        </div>
      </v-form>
      <div class="d-flex justify-end mr-3">
        <v-btn class="search-button text-none" @click="addSchedule" outlined>
          Thêm ngày giao hàng
        </v-btn>
      </div>
    </div>
    <ConfirmDialog
      ref="confirm"
      textWarning="Lưu ý: Việc xoá lịch nhận hàng cũng sẽ xoá đơn kiểm hàng nhập và hoá đơn nhập tương ứng."
      message="Bạn có chắc chắn muốn xoá lịch nhận hàng này không?"
      title="Xoá lịch nhận hàng?"
      okBtnColor="error"
      @ok="removeSchedule"
    />
  </div>
</template>

<script>
import { get } from 'lodash'
import SelectDate from '@/components/samnec/SelectDate.vue'
import BaseInput from '../../components/basic/BaseInput.vue'
import uuid from 'uuid'
import ConfirmDialog from '@/components/basic/dialog/ConfirmDialog.vue'
import api from '@/plugins/api'
import moment from 'moment'
export default {
  components: {
    BaseInput,
    SelectDate,
    ConfirmDialog
  },
  props: {
    inventory: Object,
    totalQuantity: Number
  },
  data() {
    return {
      data: {
        schedules: []
      },
      initScheduleIds: [],
      get,
      isDataChange: false
    }
  },
  methods: {
    onChangeDate(val, item) {
      item.deliveredAt = val
    },
    getData() {
      if (this.data.schedules.length === 1) {
        const raw = this.data.schedules[0]
        if (!raw.deliveredAt && !raw.quantity && !raw.billCode) {
          this.data.schedules = []
          return
        }
      }
      if (!this.$refs.form.validate()) return false
      return this.data.schedules.map(v => ({
        id: v.id,
        quantity: Number(v.quantity),
        deliveredAt: v.deliveredAt,
        billCode: v.billCode
      }))
    },
    sortScheduleStartOfDay(schedules) {
      schedules.sort((a, b) => {
        const startOfDayA = moment(a.deliveredAt).startOf('day')
        const startOfDayB = moment(b.deliveredAt).startOf('day')
        return startOfDayA.diff(startOfDayB)
      })
      return schedules
    },
    addSchedule() {
      this.data.schedules.push({
        fakeId: uuid.v4(),
        new: true,
        deliveredAt: '',
        quantity: '',
        billCode: ''
      })
    },
    async removeSchedule({ id }) {
      try {
        this.$loading.active = true
        await api['importDeliveryScheduleInventory'].remove(id)
        this.$alert.success('Xoá lịch nhận hàng thành công')
        this.data.schedules = this.data.schedules.filter(item => item.fakeId !== id)
      } catch (error) {
        this.$alert.error(error)
      } finally {
        this.$loading.active = false
      }
    },
    onRemove(id, index) {
      const schedulesIndex = this.initScheduleIds.findIndex(v => v === id)
      if (schedulesIndex > -1) this.$refs.confirm.openDialog({ id })
      else this.data.schedules.splice(index, 1)
    }
  },
  watch: {
    inventory: {
      handler(val) {
        let schedules = get(val, 'schedules', [])
        this.initScheduleIds = []
        schedules = schedules.map(item => {
          this.initScheduleIds.push(item.id)
          return {
            ...item,
            fakeId: item.id
          }
        })
        this.data.schedules = this.sortScheduleStartOfDay(schedules)
      },
      immediate: true
    },
    'data.schedules': {
      handler(val) {
        if (val.length === 0) {
          this.data.schedules.push({
            fakeId: uuid.v4(),
            new: true,
            deliveredAt: '',
            quantity: '',
            billCode: ''
          })
        }
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import './src/assets/delivery/form-inventory.scss';
</style>
